export default {
  namespaced: true,
  state: {
    diagResultId: null,
    diagResultItemId: null,
    sectionId: null,
    diagCourseId: null,
    title: '',
    diagCourseName: '',
    corpName: '',
    corpId: null,
    roughDiagId: null,
    score: 0,
    totalScore: 0,
    diagRevisionFlg: false,
    getIsOptionDiag: false,
    getSectionNotUseFlag: false,
    corporateFeatureInfoLabels: [],
    diagManagementListSearchForm: {
      selectedDiagSectionIds: [],
      selectedItemVals: ['2', '3'],
      selectedVerifiedByLaborConsultant: [],
      selectedRiskLevelIds: [],
      selectedIpoLevelIds: [],
      sortKey: {
        isDefaultSort: true,
        isSortedByCheckItem:  false,
        isSortedByDiagSection: false,
        isSortedByAnswer: false,
        isSortedByVerifiedByLaborConsultant: false,
        isSortedByIsHighPriority: false,
        isSortedByRiskLevel: false, 
        isSortedByIpoLevel: false, 
        isSortedByDueDate: false,
        isAscendingSort: false,
      },
    },
    taskListSearchForm: {
      diagSectionIds: [],
      sortKey: {
        isDefaultSort: true,
        isSortedByRiskLevel: false, 
        isSortedByIpoLevel: false, 
        isSortedByTask:  false,
        isSortedByIsHighPriority: false,
        isSortedByDueDate: false,
        isAscendingSort: false,
      },
    },
    memo: {
      title: '',
      body:'',
      attachments: [],
    },
    memoOpenFlag: false,
  },
  mutations: {
    INIT(state) {
      state.diagResultId = null;
      state.diagResultItemId = null;
      state.sectionId = null;
      state.diagCourseId = null;
      state.title = '';
      state.diagCourseName = '';
      state.corpName = '';
      state.corpId = null;
      state.roughDiagId = null;
      state.score = 0;
      state.totalScore = 0;
      state.diagRevisionFlg = false;
      state.isOptionDiag = false;
      state.sectionNotUseFlag = false;
      state.corporateFeatureInfoLabels = [];
      state.diagManagementListSearchForm = {
        selectedDiagSectionIds: [],
        selectedItemVals: ['2', '3'],
        selectedVerifiedByLaborConsultant: [],
        selectedRiskLevelIds: [],
        selectedIpoLevelIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false, 
          isSortedByIpoLevel: false, 
          isSortedByDueDate: false,
          isAscendingSort: false,
        },
      };
      state.taskListSearchForm = {
        diagSectionIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByRiskLevel: false, 
          isSortedByIpoLevel: false, 
          isSortedByTask:  false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        },
      };
      state.memo = {
        title: '',
        body:'',
        attachments: [],
      };
      state.memoOpenFlag = false;
    },
    SET_DIAG_RESULT_ID(state, payload) {
      state.diagResultId = payload;
    },
    SET_DIAG_RESULT_ITEM_ID(state, payload) {
      state.diagResultItemId = payload;
    },
    SET_SECTION_ID(state, payload) {
      state.sectionId = payload;
    },
    SET_DIAG_COURSE_ID(state, payload) {
      state.diagCourseId = payload;
    },
    SET_TITLE(state, payload) {
      state.title = payload;
    },
    SET_DIAG_COURSE_NAME(state, payload) {
      state.diagCourseName = payload;
    },
    SET_CORP_NAME(state, payload) {
      state.corpName = payload;
    },
    SET_CORP_ID(state, payload) {
      state.corpId = payload;
    },
    SET_ROUGH_DIAG_ID(state, payload) {
      state.roughDiagId = payload;
    },
    SET_SCORE(state, payload) {
      state.score = payload;
    },
    SET_TOTAL_SCORE(state, payload) {
      state.totalScore = payload;
    },
    SET_DIAG_REVISION_FLG(state, payload) {
      state.diagRevisionFlg = payload;
    },
    SET_IS_OPTION_DIAG(state, payload) {
      state.isOptionDiag = payload;
    },
    SET_SECTION_NOT_USE_FLAG(state, payload) {
      state.sectionNotUseFlag = payload;
    },
    SET_CORPORATE_FEATURE_INFO_LABELS(state, payload) {
      state.corporateFeatureInfoLabels = payload;
    },
    SET_DIAG_MANAGEMENT_LIST_SEARCH_FORM(state, payload) {
      state.diagManagementListSearchForm = payload;
    },
    SET_TASK_LIST_SEARCH_FORM(state, payload) {
      state.taskListSearchForm = payload;
    },
    INIT_EACH_SEARCH_FORM(state) {
      state.diagManagementListSearchForm = {
        selectedDiagSectionIds: [],
        selectedItemVals: ['2', '3'],
        selectedVerifiedByLaborConsultant: [],
        selectedRiskLevelIds: [],
        selectedIpoLevelIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByCheckItem:  false,
          isSortedByDiagSection: false,
          isSortedByAnswer: false,
          isSortedByVerifiedByLaborConsultant: false,
          isSortedByIsHighPriority: false,
          isSortedByRiskLevel: false, 
          isSortedByIpoLevel: false, 
          isSortedByDueDate: false,
          isAscendingSort: false,
        },
      };
      state.taskListSearchForm = {
        diagSectionIds: [],
        sortKey: {
          isDefaultSort: true,
          isSortedByRiskLevel: false, 
          isSortedByIpoLevel: false, 
          isSortedByTask:  false,
          isSortedByIsHighPriority: false,
          isSortedByDueDate: false,
          isAscendingSort: false,
        },
      };
    },
    SET_MEMO(state, payload) {
      state.memo = payload;
    },
    SET_MEMO_OPEN_FLAG(state, payload) {
      state.memoOpenFlag = payload;
    },
  },
  getters: {
    getDiagResultId(state) {
      return state.diagResultId;
    },
    getDiagResultItemId(state) {
      return state.diagResultItemId;
    },
    getSectionId(state) {
      return state.sectionId;
    },
    getDiagCourseId(state) {
      return state.diagCourseId;
    },
    getTitle(state) {
      return state.title;
    },
    getDiagCourseName(state) {
      return state.diagCourseName;
    },
    getCorpName(state) {
      return state.corpName;
    },
    getCorpId(state) {
      return state.corpId;
    },
    getRoughDiagId(state) {
      return state.roughDiagId;
    },
    getScore(state) {
      return state.score;
    },
    getTotalScore(state) {
      return state.totalScore;
    },
    getDiagRevisionFlg(state) {
      return state.diagRevisionFlg;
    },
    getIsOptionDiag(state) {
      return state.isOptionDiag;
    },
    getSectionNotUseFlag(state) {
      return state.sectionNotUseFlag;
    },
    getCorporateFeatureInfoLabels(state) {
      return state.corporateFeatureInfoLabels;
    },
    getDiagManagementListSearchForm(state) {
      return state.diagManagementListSearchForm;
    },
    getTaskListSearchForm(state) {
      return state.taskListSearchForm;
    },
    getMemo(state) {
      return state.memo;
    },
    getMemoOpenFlag(state) {
      return state.memoOpenFlag;
    },
  },
  actions: {
    init({commit}) {
      commit('INIT');
    },
    setDiagResultId({commit}, payload) {
      commit('SET_DIAG_RESULT_ID', payload);
    },
    setDiagResultItemId({commit}, payload) {
      commit('SET_DIAG_RESULT_ITEM_ID', payload);
    },
    setSectionId({commit}, payload) {
      commit('SET_SECTION_ID', payload);
    },
    setDiagCourseId({commit}, payload) {
      commit('SET_DIAG_COURSE_ID', payload);
    },
    setTitle({commit}, payload) {
      commit('SET_TITLE', payload);
    },
    setDiagCourseName({commit}, payload) {
      commit('SET_DIAG_COURSE_NAME', payload);
    },
    setCorpName({commit}, payload) {
      commit('SET_CORP_NAME', payload);
    },
    setCorpId({commit}, payload) {
      commit('SET_CORP_ID', payload);
    },
    setRoughDiagId({commit}, payload) {
      commit('SET_ROUGH_DIAG_ID', payload);
    },
    setScore({commit}, payload) {
      commit('SET_SCORE', payload);
    },
    setTotalScore({commit}, payload) {
      commit('SET_TOTAL_SCORE', payload);
    },
    setDiagRevisionFlg({commit}, payload) {
      commit('SET_DIAG_REVISION_FLG', payload);
    },
    setIsOptionDiag({commit}, payload) {
      commit('SET_IS_OPTION_DIAG', payload);
    },
    setSectionNotUseFlag({commit}, payload) {
      commit('SET_SECTION_NOT_USE_FLAG', payload);
    },
    setCorporateFeatureInfoLabels({commit}, payload) {
      commit('SET_CORPORATE_FEATURE_INFO_LABELS', payload);
    },
    setDiagManagementListSearchForm({commit}, payload) {
      commit('SET_DIAG_MANAGEMENT_LIST_SEARCH_FORM', payload);
    },
    setTaskListSearchForm({commit}, payload) {
      commit('SET_TASK_LIST_SEARCH_FORM', payload);
    },
    initEachSearchForm({commit}) {
      commit('INIT_EACH_SEARCH_FORM');
    },
    setMemo({commit}, payload) {
      commit('SET_MEMO', payload);
    },
    setMemoOpenFlag({commit}, payload) {
      commit('SET_MEMO_OPEN_FLAG', payload);
    },
  }
}